'use client';

import { useEffect } from "react";
import { closeSnackbar, useSnackbar } from "notistack";
import { useSafeSelector } from "@package/util/hooks/useSafeSelector";
import { useRouter } from "next/navigation";
import { Box, Button, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export function SnackbarListener() {
  const {
    toasterMessage = "",
    messageToaster = false,
    toasterType = "default",
    action = false,
    actionPath = "",
    actionLeble = "",
  } = useSafeSelector((state) => state.notification, {});

  const router = useRouter();

  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    if (messageToaster && toasterMessage) {
      enqueueSnackbar(toasterMessage, {
        variant: toasterType, // success | error | warning | 
        action: (snackbarId) => (
          <Box>
            {/* Optional action button */}
            {action && (
              <Button
                sx={{ color: "#fff", textTransform: "capitalize" }}
                size="small"
                onClick={() => {
                  if (actionPath) router.push(actionPath);
                  closeSnackbar(snackbarId);
                }}
                variant="outlined"
              >
                {actionLeble}
              </Button>
            )}

            {/* Close button — ALWAYS */}
            <IconButton
              onClick={() => closeSnackbar(snackbarId)}
              size="small"
              sx={{ color: "#fff" }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>
        ),
        autoHideDuration: action ? 5000 : 3000,
        preventDuplicate: true,
      });
    }
   }, [messageToaster, toasterMessage, toasterType, action, actionPath, actionLeble, enqueueSnackbar, router]);

  return null;
}
